import { type FunctionComponent } from "preact";
import MultilineText from "components/MultilineText";
import classNames from "helpers/classNames";
import styles from "./TCFPurposeItem.module.scss";
import { COL, ROW, TEXT_BOLD, FONT_ITALIC } from "styles/bootstrap";
import Accordion from "components/Accordion";
import noop from "helpers/noop";
import Switch from "components/Switch";
import useTranslation from "hooks/useTranslation";
import { FALSE, NULL, UNDEFINED } from "constants/primitives";
import { LTR } from "helpers/getTextDirection";

const cx = classNames(styles);

const TCFPurposeItem: FunctionComponent<ITCFPurposeItemProps> = ({
  title = "",
  description = "",
  illustrations = [],
  hasSwitch = FALSE,
  hasLegitimateInterest = FALSE,
  onPurposeToggle = noop,
  onLegitimateInterestToggle = noop,
  isAccepted,
  isLegitimateInterestAccepted,
  numberOfVendors,
}) => {
  const { t, textDirection } = useTranslation();
  const trans = (key: string) => t(`vendors.${key}`);

  return (
    <Accordion
      title={title}
      titleTag={"h4"}
      badge={
        numberOfVendors ? `${numberOfVendors} ${t("modal.vendors")}` : UNDEFINED
      }
      customSwitcher={
        hasSwitch && hasLegitimateInterest ? (
          <>
            {
              <Switch
                onChange={onPurposeToggle}
                aria-label={title}
                checked={!!isAccepted}
                label={trans("dataProcessing")}
                className={cx(
                  "switch",
                  "w-100",
                  "pr-0",
                  textDirection === LTR ? "justify-content-end" : ""
                )}
              />
            }
            {
              <Switch
                onChange={onLegitimateInterestToggle}
                aria-label={title}
                checked={!!isLegitimateInterestAccepted}
                label={trans("legInt")}
                className={cx(
                  "switch",
                  "w-100",
                  "pr-0",
                  textDirection === LTR ? "justify-content-end" : ""
                )}
              />
            }
          </>
        ) : hasSwitch ? (
          <Switch
            onChange={onPurposeToggle}
            aria-label={title}
            checked={!!isAccepted}
            label={trans("dataProcessing")}
            className={cx(
              "w-100",
              "pr-0",
              textDirection === LTR ? "justify-content-end" : ""
            )}
          />
        ) : (
          NULL
        )
      }
    >
      <div class={cx(ROW)}>
        <div class={cx(COL)}>
          <MultilineText text={description} />
          {illustrations && Object.keys(illustrations).length > 0 && (
            <>
              <div class={cx(TEXT_BOLD, "pt-2")}>
                <h5>{trans("illustrations")}</h5>
              </div>
              {Object.values(illustrations).map((illustration, index) => {
                return (
                  <MultilineText
                    key={`text-${index}`}
                    blockClasses={["p-2", FONT_ITALIC]}
                    text={illustration}
                  />
                );
              })}
            </>
          )}
        </div>
      </div>
    </Accordion>
  );
};

export interface ITCFPurposeItemProps {
  title: string;
  description: string;
  illustrations: object;
  hasSwitch: boolean;
  hasLegitimateInterest: boolean;
  onPurposeToggle: () => void;
  onLegitimateInterestToggle: () => void;
  isAccepted?: boolean;
  isLegitimateInterestAccepted?: boolean;
  numberOfVendors?: number;
}

export default TCFPurposeItem;
